import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import './otStyle.css';
import config from '../../config.json';
import OTLabel from './OTLabel'

const apiUrl = config.apiUrl;

const OTApproved = () => {
    const [overtimeData, setOvertimeData] = useState({
        TransactionID: '',
        TransactionDate: '',
        Employee: [],
        DateStart: '',
        DateEnd: '',
        Duration: '',
        Remarks: '',
        Status: '',
    });

    const { overtimeId } = useParams();
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [isDisable, setIsDisable] = useState(false);
    const navigate = useNavigate();
    const roles = JSON.parse(localStorage.getItem('Roles'));

    const userAccess = {
        hasView: roles?.includes('View') || false,
        hasAdmin: roles?.includes('Admin') || false,
        hasApprover: roles?.includes('Approver') || false,
        hasStandard: roles?.includes('Standard') || false,
    };

    const { hasView, hasAdmin, hasStandard, hasApprover } = userAccess;

    useEffect(() => {
        const fetchOvertimeData = async () => {
            if (!overtimeId) return;

            setIsDisable(true);

            try {
                const token = localStorage.getItem('token');
                const response = await fetch(`${apiUrl}/Overtime/${overtimeId}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (!response.ok) {
                    setErrorMessage('Failed to fetch overtime data');
                    setSuccessMessage('');
                    return;
                }

                const data = await response.json();
                setOvertimeData({
                    TransactionID: data.Details.TransactionID,
                    TransactionDate: data.Details.TransactionDate,
                    Employee: data.Details.Employee,
                    DateStart: data.Details.DateStart,
                    DateEnd: data.Details.DateEnd,
                    Duration: data.Details.Duration,
                    Remarks: data.Details.Remarks,
                    Status: data.Details.Status,
                });

                setIsDisable(false);
            } catch (error) {
                setErrorMessage('Error fetching overtime data');
                setSuccessMessage('');
                setIsDisable(false);
            }
        };

        fetchOvertimeData();
    }, []);

    const handleInputChange = (e) => {
        setOvertimeData({ ...overtimeData, [e.target.name]: e.target.value });
    };

    const handleForSubmit = async (e) => {
        e.preventDefault();

        // Disable the button when the API process starts
        setIsDisable(true);

        const { Remarks } = overtimeData;

        const approvedOvertime = {
            Remarks,
        };

        const token = localStorage.getItem('token');
        try {
            const response = await fetch(`${apiUrl}/Overtime/Approve/${overtimeId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(approvedOvertime),
            });

            const data = await response.json();
            if (!response.ok) {
                setErrorMessage('Approve failed!');
                setSuccessMessage('');
            }

            setErrorMessage('');
            setSuccessMessage(data.Message);

            // Enable the button after the API process completes
            setIsDisable(false);

            navigate('/overtime-list');
        } catch (error) {
            setErrorMessage('Error approval');
            setSuccessMessage('');
            setIsDisable(false);
        }
    };

    const {
        TransactionID,
        TransactionDate,
        Employee,
        DateStart,
        DateEnd,
        Duration,
        Remarks,
        Status,
    } = overtimeData;

    return (
        <div>
            {(userAccess.hasAdmin || userAccess.hasApprover) ? (
                <>
                    <h3>Approve Overtime</h3>
                    {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                    {successMessage && <div className="alert alert-success">{successMessage}</div>}
                    <form onSubmit={handleForSubmit}>
                        <div className="row mt-4">
                            <OTLabel label="Transaction ID" value={TransactionID} />
                            <OTLabel label="Transaction Date" value={TransactionDate} />
                            <OTLabel label="Employee" value={Employee.Name} />
                            <OTLabel label="Date Start" value={DateStart} />
                            <OTLabel label="Date End" value={DateEnd} />
                            <OTLabel label="Duration" value={Duration} />
                            <OTLabel label="Status" value={Status} />
                            <div className="mb-2">
                                <label htmlFor="remarks" className="form-label bold-label">Remarks</label>
                                <input
                                    type="text"
                                    className="form-control custom-width"
                                    id="remarks"
                                    name="Remarks"
                                    value={Remarks}
                                    onChange={handleInputChange}
                                    maxLength={500}
                                />
                            </div>
                            <div className="mb-2">
                                <Link to="/overtime-list" className="btn btn-secondary me-2">Back</Link>
                                {(userAccess.hasApprover || userAccess.hasAdmin) && (
                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                        disabled={isDisable} // Disable the button based on the isApproving state
                                    >
                                        Approve
                                    </button>
                                )}
                            </div>
                        </div>
                    </form>
                </>
            ) : (
                <div>
                    <h3>No access!</h3>
                    <button className="btn btn-primary" onClick={() => navigate(-1)}>
                        Go Back
                    </button>
                </div>
            )}
        </div>
    );
};

export default OTApproved;
